import PathList from "../Common/PathList";
import DashboardA from "../Assets/SidebarActiveIcons/DashboardA.svg";
import Dashboard from "../Assets/SidebarInactive/Dashboard.svg";
import ManageNewsA from "../Assets/SidebarActiveIcons/ManageNewsA.svg";
import ManageNews from "../Assets/SidebarInactive/ManageNews.svg";
import ManagePeopleA from "../Assets/SidebarActiveIcons/ManagePeopleA.svg";
import ManagePeople from "../Assets/SidebarInactive/ManagePeople.svg";
import ManageClubA from "../Assets/SidebarActiveIcons/ManageClubA.svg";
import ManageClub from "../Assets/SidebarInactive/ManageClub.svg";
import CenterManagementA from "../Assets/SidebarActiveIcons/CenterManagementA.svg";
import CenterManagement from "../Assets/SidebarInactive/CenterManagement.svg";
import ManageFixturesA from "../Assets/SidebarActiveIcons/ManageFixturesA.svg";
import ManageFixtures from "../Assets/SidebarInactive/ManageFixtures.svg";
import ManageUserA from "../Assets/SidebarActiveIcons/ManageUserA.svg";
import ManageUser from "../Assets/SidebarInactive/ManageUser.svg";
import AddNewReportA from "../Assets/SidebarActiveIcons/AddNewReportA.svg";
import AddNewReport from "../Assets/SidebarInactive/AddNewReport.svg";

export const NavMenuList = [
  // {
  //   title: "Dashboard",
  //   path: PathList.Dashboard,
  //   active: DashboardA,
  //   icon: Dashboard,
  // },
  // {
  //   title: "Manage News",
  //   path: PathList.ManageNews,
  //   active: ManageNewsA,
  //   icon: ManageNews,
  // },
  // {
  //   title: "Manage Players",
  //   path: PathList.ManagePlayer,
  //   active: ManagePeopleA,
  //   icon: ManagePeople,
  // },
  {
    title: "Manage Club",
    path: PathList.ManageClub,
    active: ManageClubA,
    icon: ManageClub,
  },
  // {
  //   title: "Center Management",
  //   path: PathList.CenterManagement,
  //   active: CenterManagementA,
  //   icon: CenterManagement,
  // },
  // {
  //   title: "Add New Report",
  //   path: PathList.AddNewReport,
  //   active: AddNewReportA,
  //   icon: AddNewReport,
  // },
  // {
  //   title: "Manage Fixtures",
  //   path: PathList.ManageFixtures,
  //   active: ManageFixturesA,
  //   icon: ManageFixtures,
  // },
  // {
  //   title: "Manage User",
  //   path: PathList.ManageUser,
  //   active: ManageUserA,
  //   icon: ManageUser,
  // },
];
